<template>
  <section class="single-cat">
    <article>
      <div class="row clearfix">
        <h1>
          Special Events
          <!-- <a href="javascript:;" data-table="category-trends-table" class="infotoggle inline tooltipstered">Click for more info</a> -->
        </h1>
        <div class="sixcol">
          <p>In 2025, <strong>Special Events</strong> generated $7.0m in revenue and attracted over 0.2m attendances.</p>
          <p><strong>Special Events</strong> recorded a y-o-y decline in revenue of 30.1% (from $10.0m in 2024 to $7.0m in 2025) and a y-o-y decline in attendance of 10.4% (from 0.3m in 2024 to 0.2m in 2025).</p>
          <p>The average ticket price decreased by 33.6% y-o-y (from $59.62 in 2024 to $39.60 in 2025), which further contributed to the decline in revenue.</p>
          <p><strong>Special Events</strong> accounted for 0.2% of the overall live performance revenue and 0.8% of the total attendance in 2025.</p>
          <p>The top events in this category in 2025 were <em>The Christmas Spectacular</em>, <em>RocKwiz Live!</em>, <em>Rupaul's Drag Race</em>, <em>Bonfire Night 2025</em> and <em>Carols by Candlelight</em>.</p>
        </div>
        <div class="sixcol last">
          <p>In 2025, QLD, VIC and NSW generated the most revenue and attendance in this category. These three states generated 84.3% of overall revenue and 86.9% of attendance in this category in 2025.</p>
          <p>All states and territories except QLD recorded a y-o-y decline in both revenue and attendance in this category in 2025.</p>
          <p>QLD recorded y-o-y growth in revenue (17.5%) and attendance (78.8%) in 2025. Top events in QLD included <em>Rupaul's Drag Race</em>, <em>The Christmas Spectacular</em> and <em>RocKwiz Live!</em>.</p>
          <p>VIC recorded a y-o-y decline in revenue (36.2%) and attendance (27.3%) in 2025. Top events in VIC included <em>Carols by Candlelight</em>, <em>RocKwiz Live!</em>, <em>Rupaul's Drag Race</em>, and <em>The Greatest Christmas Show</em>.</p>
          <p>NSW recorded a y-o-y decline in revenue (47.7%) and attendance (35.9%) in 2025. Top events in NSW included <em>The Christmas Spectacular</em>, <em>Rupaul's Drag Race</em>, <em>RocKwiz Live!</em> and <em>ABC New Year’s Eve Concert</em>.</p>
          <p>The <strong>Special Events</strong> category is highly variable as it is dependent on whether events can be classified into other categories or not.</p>
        </div>
      </div>
    </article>

    <figure class="chart">
      <div class="row clearfix">
        <highcharts class="graphcontainer" :options="totalRevenueAttendance"></highcharts>
      </div>
    </figure>

    <figure id="classical-music-states" class="chart">
      <div class="row clearfix">
        <h1>State/Territory Breakdown</h1>

        <div class="chart-wrapper">
          <highcharts class="graphcontainer" :options="activeStateBreakdown"></highcharts>
          <div class="nb">NB: Numbers may not total 100.0% due to rounding.<br>Categories/States with zero or &lt;0.05% of revenue and/or attendance<br> may not be reflected in the pie chart.</div>
        </div>
      </div>
    </figure>

    <div class="fullbg">
      <p class="caption">Photo: <em>Gapu Ŋupan (Chasing the Rainbow)</em>, Artback NT, Hui Jia Creatives, Kath Papas Productions, and Miku Performing Arts, Photo Credit: Sakinu Kazangilijan</p>
    </div>
  </section>
</template>

<script>
/*eslint-disable */

export default {
  data () {
    return {
      totalRevenueAttendance: {
        chart: {
          backgroundColor: null,
        },
        title: {
          text: ''
        },
        xAxis: [{
          categories: ["2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
          labels: {
            style: {
              color: '#fff'
            }
          }
        }],
        yAxis: [{ // Primary yAxis
          min: 0,
          labels: {
            formatter: function() {
              if (this.value > 999) {
                return '$' + (this.value / 1000) + 'b'
              } else {
                return '$' + this.value + 'm'
              }
            },
            style: {
              color: '#fff'
            }
          },
          title: {
            text: 'Gross Revenue',
            style: {
              color: '#fff'
            }
          },
          opposite: true
        }, { // Secondary yAxis
          min: 0,
          labels: {
            formatter: function() {
              if (this.value < 1) {
                return (this.value * 1000) + 'k'
              } else {
                return this.value + 'm'
              }
            },
            style: {
              color: '#fff'
            }
          },
          title: {
            text: 'Total Attendance',
            style: {
              color: '#fff'
            }
          },
          opposite: false
        }],
        tooltip: {
          shared: true,
          formatter: function() {
            let revy, tooltipstring;
            let rev = this.points[0];
            let att = this.points[1];
            let atty = att.y + 'm';
            let chart = this.points[0].series.chart;
            let categories = chart.xAxis[0].categories;
            let index = 0;
            while (this.x !== categories[index]) {
              index++;
            }
            if (rev.y > 1000) {
              revy = '$' + (rev.y / 1000).toFixed(3) + 'b'
            } else {
              revy = '$' + rev.y.toFixed(3) + 'm'
            }
            if (att.y < 1) {
              atty = (att.y * 1000).toFixed(0) + 'k'
            } else {
              atty = att.y + 'm'
            }

            tooltipstring = this.x + '<br />';
            tooltipstring += '<span style="color:' + rev.series.color + '">•</span> Revenue: ' + revy + '<br />'
            tooltipstring += '<span style="color:' + att.series.color + '">•</span> Attendance: ' + atty + '<br />'
            return tooltipstring
          }
        },
        legend: {
          layout: 'vertical',
          align: 'center',
          verticalAlign: 'bottom',
          floating: false,
          backgroundColor: '#FFFFFF'
        },
        series: [{
          name: 'Revenue',
          type: 'column',
          data: [96.706, 89.357, 82.144, 117.204, 10.325, 23.602, 31.45, 15.8, 4.25, 6.03, 10.984, 20.341, 29.311, 5.05, 22.115, 21.352, 4.644, 2.602, 4.848, 3.159, 9.965, 6.965],
          color: '#3a89eb'
        }, {
          name: 'Attendance',
          type: 'column',
          yAxis: 1,
          data: [3.125, 2.992, 2.626, 3.453, 0.375, 0.559, 0.527, 0.37, 0.091, 0.113, 0.21, 0.557, 0.185, 0.137, 0.17, 0.431, 0.167, 0.079, 0.143, 0.195, 0.262, 0.235],
          color: '#d14967'
        }]
      },
      activeYear: 2025,
      stateBreakdowns: [
        {
          year: 2025,
          revenue: [
            ["NSW", 22.6],
            ["VIC", 28.6],
            ["QLD", 33.1],
            ["WA", 7.1],
            ["SA", 2.9],
            ["ACT", 4.0],
            ["TAS", 1.8],
            ["NT", 0.0],
          ],
          attendance: [
            ["NSW", 16.6],
            ["VIC", 19.2],
            ["QLD", 51.1],
            ["WA", 7.5],
            ["SA", 1.9],
            ["ACT", 1.8],
            ["TAS", 1.9],
            ["NT", 0.0],
          ]
        }
      ],
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  computed: {
    activeStateBreakdown () {
      const self = this

      for (let i = 0; i < self.stateBreakdowns.length; i++) {
        const stateBreakdown = self.stateBreakdowns[i]
        if (stateBreakdown.year === self.activeYear) {
          return {
            chart: {
              type: 'pie',
              backgroundColor: 'transparent'
            },
            title: {
              text: ''
            },
            subtitle: {
              text: ''
            },
            plotOptions: {
              series: {
                states: {
                  inactive: {
                    opacity: 1
                  }
                }
              },
              pie: {
                shadow: false,
                center: ['50%', '50%'],
                dataLabels: {
                  enabled: true,
                  style: {
                    fontWeight: 'bold',
                    color: 'white',
                    textShadow: '0px 1px 2px black'
                  }
                },
                point: {
                  events: {
                    legendItemClick: e => {
                      e.preventDefault();
                      return false;
                    }
                  }
                }
              }
            },
            legend: {
              align: 'right',
              layout: 'vertical',
              verticalAlign: 'middle',
              itemMarginBottom: 10,
              itemStyle: {
                color: '#fff'
              },
              itemHoverStyle: {
                color: '#fff'
              }
            },
            tooltip: {
              valueSuffix: '%',
              valueDecimals: 1
            },
            series: [
              {
                name: 'Attendance Share',
                data: stateBreakdown.attendance,
                size: '68%',
                innerSize: '40%',
                borderColor: 'none',
                borderWidth: 1,
                slicedOffset: 30,
                showInLegend: true,
                dataLabels: {
                  color: '#000',
                  style: {
                    textShadow: 'none',
                  },
                  formatter: function() {
                    if (this.y > 3) {
                      return this.y.toFixed(1) + '% '
                    }
                  },
                  distance: -28
                }
              }, 
              {
                name: 'Revenue Share',
                data: stateBreakdown.revenue,
                size: '100%',
                innerSize: '70%',
                borderColor: 'transparent',
                borderWidth: 1,
                dataLabels: {
                  color: '#000',
                  style: {
                    textShadow: 'none',
                  },
                  formatter: function() {
                    if (this.y > 3) {
                      return this.y.toFixed(1) + '% '
                    }
                  },
                  distance: -32
                }
              }
            ],
            colors: [
              '#f66262',
              '#f2914a',
              '#5fa62b',
              '#6598d3',
              '#594ebb',
              '#bc56c3',
              '#c3567f',
              '#edc055'
            ]
          }
        }
      }

      return false
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.single-cat {
  background-image: url("~@/assets/img/2025/28-Special-Events-IMG_9609--Sakinu-Kazangiljan-(2).jpg");
}
.chart-wrapper {
  position: relative;
  .nb {
    position: absolute;
    bottom: 0;
    right: 0;
    color: #fff;
    font-style: italic;
    font-size: 12px;
  }
}
</style>
